var successAgreedStage2 = {
    requestId: '5e9d7966-66e6-442f-8afe-8db8faa1f73d',
    timestamp: '2024-07-18 12:02:37',
    type: 'LOAN_DETAILS',
    data: {
        preLimitId: 1721296939,
        loan: {
            id: 1721296947,
            amount: 15330,
            currency: 'PLN',
            period: 12,
            pricing: 30,
            loanRepaymentPrice: 3.6,
            name: 'TEST_LOAN',
            iban: 'PL68102045645609879769242394',
            createdAt: '2024-07-18 12:02:37',
            provider: 'test-provider',
            stage: 2,
            providerRequest: 'gotNotification',
            sms: [],
            loanRepaymentAccounts: ['193421', '1234', '4321'],
            previousStage: 1,
            loanAmountChange: false,
            documents: [
                {
                    url: 'https://www.przelewy24.pl/storage/app/media/dokumenty/ocena-stosowania-zasad-ladu-korporacyjnego-paypro-sa-2022.pdf',
                    type: 'test-provider-contract',
                },
                {
                    url: 'https://www.przelewy24.pl/storage/app/media/dokumenty/Podstawowa%20struktura%20organizacyjna%20PayPro%20SA.pdf?1',
                    type: 'p24-contract',
                },
            ],
        },
        status: 'AGREED',
        stage: 2,
        value: {
            amount: 15330,
            currency: 'PLN',
        },
        documents: [
            {
                url: 'https://www.przelewy24.pl/storage/app/media/dokumenty/ocena-stosowania-zasad-ladu-korporacyjnego-paypro-sa-2022.pdf',
                type: 'test-provider-contract',
            },
            {
                url: 'https://www.przelewy24.pl/storage/app/media/dokumenty/Podstawowa%20struktura%20organizacyjna%20PayPro%20SA.pdf?1',
                type: 'p24-contract',
            },
        ],
        limit: {
            id: 1721296939,
            min: 3000,
            max: 15330,
            used: 15330,
            currency: 'PLN',
            provider: 'test-provider',
            availableLimitRevenueRate: [
                {
                    period: 12,
                    pricing: 30,
                    loanRepaymentPrice: 3.6,
                    amountMin: 10000,
                    amountMax: 20000,
                },
                {
                    period: 6,
                    pricing: 30,
                    loanRepaymentPrice: 3.6,
                    amountMin: 10000,
                    amountMax: 20000,
                },
            ],
            minMaxDifference: false,
            available: 15330,
        },
    },
};
var successRejectedStage7 = {
    requestId: '47d9d8d4-5a91-4980-8bfa-04599995f219',
    timestamp: '2024-07-18 12:38:23',
    type: 'LOAN_DETAILS',
    data: {
        preLimitId: 1721299100,
        limitId: 1721299100,
        loanId: 1721299103,
        providerRequest: 'requested',
        status: 'REJECTED',
        rejectionReason: 'Nie odnaleziono firmy z numerem NIP: 8885411259',
        rejectionDescription: [
            'Posiadasz opóźnienia w płatnościach wobec PragmaGO.',
            'Podane przez Ciebie dane nie zgadzają się z danymi w BIK.',
        ],
    },
};
export var getLoanMock = {
    successAgreedStage2: successAgreedStage2,
    successRejectedStage7: successRejectedStage7,
};
